var _excluded = ["fontFamily", "src"];

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { arrayReduce } from 'fast-loops';
import isPlainObject from 'isobject';

function renderFontFace(fontFace, renderer) {
  if (typeof fontFace === 'string') {
    return fontFace;
  }

  var fontFamily = fontFace.fontFamily,
      src = fontFace.src,
      otherProps = _objectWithoutProperties(fontFace, _excluded);

  if (typeof fontFamily === 'string' && Array.isArray(src)) {
    return renderer.renderFont(fontFamily, src, otherProps);
  } // TODO: warning - invalid font data


  return undefined;
}

function embeddedPlugin(style, type, renderer, props) {
  var _loop = function _loop(property) {
    var value = style[property];

    if (property === 'fontFace' && _typeof(value) === 'object') {
      if (Array.isArray(value)) {
        style.fontFamily = arrayReduce(value, function (fontFamilyList, fontFace) {
          var fontFamily = renderFontFace(fontFace, renderer);

          if (fontFamily && fontFamilyList.indexOf(fontFamily) === -1) {
            fontFamilyList.push(fontFamily);
          }

          return fontFamilyList;
        }, []).join(',');
      } else {
        style.fontFamily = renderFontFace(value, renderer);
      }

      delete style.fontFace;
    } else if (property === 'animationName' && _typeof(value) === 'object') {
      if (Array.isArray(value)) {
        style[property] = value.map(function (frame) {
          return renderer.renderKeyframe(function () {
            return frame;
          });
        }, props).join(',');
      } else {
        style[property] = renderer.renderKeyframe(function () {
          return value;
        }, props);
      }
    } else if (isPlainObject(value)) {
      embeddedPlugin(value, type, renderer, props);
    }
  };

  for (var property in style) {
    _loop(property);
  }

  return style;
}

export default function embedded() {
  return embeddedPlugin;
}